import { usePollDocument, usePollDocumentSummary } from './hooks'

interface DocumentPollerProps {
  documentId: string
}

export const DocumentPoller: React.FC<DocumentPollerProps> = ({ documentId }) => {
  usePollDocument(documentId)
  usePollDocumentSummary(documentId)

  return null
}
